import { Navigate } from "react-router-dom";
import { lazy } from "react";

const LoginPage = lazy(() => import("../pages/login.jsx"));
const ForgotPassword = lazy(() => import("../pages/forgotPassword.jsx")); 
const Otp = lazy(() => import("../pages/otp.jsx"));
const ChangePassword = lazy(() => import("../pages/changePassword.jsx"));
const ResetSuccess = lazy(() => import("../pages/resetSuccess.jsx"));

export const commonRoutes = [
  { 
    path: "/",
    element: <Navigate to="/login" replace />
  },
  {
    path: "/login",
    element: <LoginPage/> ,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword/> ,
  },
  {
    path: "/otp",
    element: <Otp/> ,
  },
  {
    path: "/change-password",
    element: <ChangePassword/> ,
  },
  {
    path: "/reset-success",
    element: <ResetSuccess/> ,
  },
]